<template>
    <div class="ddxq">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="ddxq-ads">
            <van-cell-group custom-class="goods-cell-group" :border="false">
                <van-cell is-link @click="toAddress" v-if="order.orderStatus==0">
                    <div class="ads-info" v-if="addressInfo">
                        <span>{{addressInfo.province}}{{addressInfo.city}}{{addressInfo.county}}</span>
                        <span style="font-weight: bold;">{{addressInfo.addressDetail}}</span>
                        <span>{{addressInfo.name}} {{addressInfo.adsPhone}}</span>
                    </div>
                    <div class="ads-info" v-else>
                        <span>添加地址</span>
                    </div>
                </van-cell>
                <van-cell v-if="order.orderStatus!=0">
                    <div class="ads-info" v-if="addressInfo">
                        <span>{{addressInfo.province}}{{addressInfo.city}}{{addressInfo.county}}</span>
                        <span style="font-weight: bold;">{{addressInfo.addressDetail}}</span>
                        <span>{{addressInfo.name}} {{addressInfo.adsPhone}}</span>
                    </div>
                    <div class="ads-info" v-else>
                        <span>添加地址</span>
                    </div>
                </van-cell>
            </van-cell-group>
        </div>
        <div style="background-color: #EEEEEE;padding: 5px 0px; margin: 0px 5px;">
            <div class="zhongbu">
                <van-cell-group custom-class="goods-cell-group" :border="false">
                    <van-cell icon="shop-o">
                        <div style="display: flex;flex-direction: row;justify-content: space-between">
                            <span style="font-size: 12px">{{deptName}}</span>
                            <span style="font-size: 12px;color: #ff4d51">{{map[order.orderStatus]}}</span>
                        </div>
                    </van-cell>
                </van-cell-group>
                <div class="spu-item" v-for="sku in skus">
                    <van-card
                            :num="sku.skuNum"
                            :price="sku.sellingPrice"
                            :origin-price="sku.costPrice"
                            :desc="sku.specs"
                            :title="sku.spuName"
                            :thumb="sku.imgUrl"
                    />
                </div>
                <div style="width: 95%;margin: auto;margin-top: 18px">
                    <van-cell-group custom-class="goods-cell-group" :border="false">
                        <van-cell>
                            <div style="display: flex;flex-direction: row;justify-content: space-between">
                                <span style="font-size: 12px">配送方式</span>
                                <span style="font-size: 12px">{{order.shippingType==0?'到店自提':'快递发货'}}</span>
                            </div>
                        </van-cell>
                    </van-cell-group>
                </div>
            </div>
            <div style="background-color: #EEEEEE;padding: 5px 0px 0px 0px">
                <div class="zhongbu">
                    <div style="width: 95%;margin: auto;">
                        <van-cell-group custom-class="goods-cell-group" :border="false">
                            <van-cell>
                                <div style="display: flex;flex-direction: row;justify-content: space-between">
                                    <span style="font-size: 12px">商品金额</span>
                                    <span style="font-size: 12px">¥{{order.totalPrice}}</span>
                                </div>
                            </van-cell>
                        </van-cell-group>
                        <van-cell-group custom-class="goods-cell-group" :border="false" v-if="order.vipPrice">
                            <van-cell>
                                <div style="display: flex;flex-direction: row;justify-content: space-between">
                                    <span style="font-size: 12px">PLUS会员</span>
                                    <span style="font-size: 12px">-¥{{order.vipPrice}}</span>
                                </div>
                            </van-cell>
                        </van-cell-group>
                        <van-cell-group custom-class="goods-cell-group" :border="false">
                            <van-cell>
                                <div style="display: flex;flex-direction: row;justify-content: space-between">
                                    <span style="font-size: 12px">运费</span>
                                    <span style="font-size: 12px">¥0</span>
                                </div>
                            </van-cell>
                        </van-cell-group>
                        <van-cell-group custom-class="goods-cell-group" :border="false">
                            <van-cell>
                                <div style="display: flex;flex-direction: row;justify-content: space-between">
                                    <span style="font-size: 12px">实付款</span>
                                    <span style="font-size: 12px;color: #ff4d51">¥{{order.payPrice}}</span>
                                </div>
                            </van-cell>
                        </van-cell-group>
                    </div>
                </div>
            </div>
            <div style="background-color: #EEEEEE;padding: 5px 0px 0px 0px">
                <div class="zhongbu">
                    <div style="width: 95%;margin: auto;display: flex;flex-direction: column;">
                        <van-cell-group custom-class="goods-cell-group" :border="false"
                                        v-if="order.orderStatus==2||order.orderStatus==3">
                            <van-cell>
                                <div style="display:flex;;flex-direction: row;justify-content: space-between;align-items: center">
                  <span style="height: 18px;line-height: 18px;font-size: 13px">快递单号: <span
                          style="color: #888888;font-size: 10px" ref="p">{{order.courierNo}}</span></span>
                                    <p class="el-icon-document-copy" data-clipboard-action="copy" @click="copy"></p>
                                </div>
                            </van-cell>
                        </van-cell-group>
                        <van-cell-group custom-class="goods-cell-group" :border="false">
                            <van-cell>
                <span style="height: 18px;line-height: 18px;font-size: 13px">订单号: <span
                        style="color: #888888;font-size: 10px">{{order.orderNo}}</span></span>
                            </van-cell>
                        </van-cell-group>
                        <van-cell-group custom-class="goods-cell-group" :border="false">
                            <van-cell>
                <span style="height: 18px;line-height: 18px;font-size: 13px">下单时间: <span
                        style="color: #888888;font-size: 10px">{{order.createTime}}</span></span>
                            </van-cell>
                        </van-cell-group>
                        <van-cell-group custom-class="goods-cell-group" :border="false" v-if="order.orderStatus!=0">
                            <van-cell>
                <span style="height: 18px;line-height: 18px;font-size: 13px">支付时间: <span
                        style="color: #888888;font-size: 10px">{{order.payTime}}</span></span>
                            </van-cell>
                        </van-cell-group>
                    </div>
                </div>
            </div>
            <div style="background-color: #EEEEEE;padding: 5px 0px 0px 0px" v-if="order.orderStatus==0">
                <div class="zhongbu">
                    <div style="width: 95%;margin: auto;">
                        <van-radio-group v-model="payType" style="margin-top: 10px">
                            <van-radio :name="item.value" checked-color="#07c160" class="radio-btn"
                                       v-for="item in payTypes">
                                <span>{{item.name}}</span>
                                <span style="margin-left: 5px;color: #F59004" v-if="item.name=='金豆支付'">{{mb.goldCoin}}</span>
                            </van-radio>
                        </van-radio-group>
                    </div>
                </div>
            </div>
            <van-goods-action v-if="order.orderStatus==0">
                <van-goods-action-button/>
                <van-goods-action-button/>
                <van-button type="default" text="取消" @click="delOrder(order.id)" class="odqx-btn"/>
                <van-button type="default" text="付款" @click="toZhifu(order.id)" class="odzf-btn"/>
            </van-goods-action>
<!--            <van-goods-action v-if="order.orderStatus==1">-->
<!--                <van-goods-action-button/>-->
<!--                <van-goods-action-button/>-->
<!--                <van-button type="default" text="退款" @click="refund(order.id)" class="odqx-btn"/>-->
<!--            </van-goods-action>-->
            <van-goods-action v-if="order.orderStatus==2">
                <van-goods-action-button/>
                <van-goods-action-button/>
                <van-button type="default" text="确认收货" @click="updateOrder(order.id)" class="odzf-btn"/>
            </van-goods-action>
        </div>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";

    let adsId;
    export default {
        data() {
            return {
                title: '订单详情',
                deptId: '',
                deptName: '',
                token: '',
                orderId: '',
                adsId: '',
                order: {},
                skus: [],
                addressInfo: {},
                payTypes: [
                    {'name': '微信支付', 'value': 0},
                    {'name': '金豆支付', 'value': 2},
                ],
                mb:{},
                map: {
                    '0': '待付款',
                    '1': '待发货',
                    '2': '已发货',
                    '3': '已完成',
                    '6': '待拼团',
                },

                payType: 0,
                chosenCoupon: -1,
                coupons: [],
                showList: false,

            };
        },
        beforeRouteEnter(to, from, next) {
            adsId = from.params.hasOwnProperty('adsId') ? from.params.adsId : ''
            next();
        },
        async created() {
            document.title = getDeptName()
            this.deptId = getDeptId()
            this.token = getCookie('spmToken')
            this.orderId = this.$route.params.orderId
            if (adsId) {
                this.adsId = adsId
                await this.updateOrderAds(adsId)
            } else {
                await this.getOrderDetail()
            }
            await this.getMember()
            await this.getAddress()
        },
        methods: {
            async getAddress() {
                let data = {
                    adsId: this.adsId,
                    token: this.token
                }
                let res = await this.$get("/spm/getSpmAddressInfo", data)
                this.addressInfo = res.info
            },

            async getOrderDetail() {
                let res = await this.$get("/spm/getSpmOrderDetail", {orderId: this.orderId})
                this.order = res.order
                this.deptName = res.deptName
                this.skus = res.order.skus
                this.adsId = res.order.addressId
            },
            async getMember() {
                let res = await this.$get("/spm/getSpmMember", {token: this.token})
                this.mb = res.mb
            },

            async updateOrderAds(adsId) {
                let data = {
                    orderId: this.orderId,
                    adsId: adsId,
                }
                let res = await this.$post("/spm/updateSpmOrderAds", data)
                if (res.code == 200) {
                    this.getOrderDetail()
                } else {
                }
            },

            //选择地址
            toAddress() {
                this.$router.push('/address/' + this.deptId)
            },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },

            //删除订单
            async delOrder(orderId) {
                this.$dialog.confirm({
                    title: '操作',
                    message: '是否取消订单？'
                }).then(async () => {
                    let data = {
                        orderId: orderId
                    }
                    let res = await this.$post("/spm/delSpmOrder", data)
                    if (res.code == 200) {
                        this.$notify({
                            message: res.message,
                            duration: 1000,
                            background: '#1989fa'
                        });
                        this.onClickLeft()
                    } else {
                        this.$notify({
                            message: res.message,
                            duration: 1000,
                            background: 'red'
                        });
                    }
                }).catch(() => {
                    console.log("取消")
                });
            },
            //确认收货
            async updateOrder(orderId) {
                this.$dialog.confirm({
                    title: '操作',
                    message: '是否确认收货？'
                }).then(async () => {
                    let data = {
                        id: orderId,
                        orderStatus: "3",
                    }
                    let res = await this.$post("/spm/updateSpmOrder", data)
                    if (res.code == 200) {
                        this.$notify({
                            message: res.message,
                            duration: 1000,
                            background: '#1989fa'
                        });
                        this.onClickLeft()
                    } else {
                        this.$notify({
                            message: res.message,
                            duration: 1000,
                            background: 'red'
                        });
                    }
                }).catch(() => {
                    console.log("取消")
                });
            },

            // //退款
            // refund(orderId) {
            //     this.$dialog.confirm({
            //         title: '操作',
            //         message: '是否退款？？'
            //     }).then(async () => {
            //         let data = {
            //             orderId: orderId,
            //             orderStatus: "3",
            //         }
            //         let res = await this.$post("/api/refundOrder", data)
            //         if (res.code == 200) {
            //             this.$notify({
            //                 message: res.message,
            //                 duration: 1000,
            //                 background: '#1989fa'
            //             });
            //             this.onClickLeft()
            //         } else {
            //             this.$notify({
            //                 message: res.message,
            //                 duration: 1000,
            //                 background: 'red'
            //             });
            //         }
            //     }).catch(() => {
            //         console.log("取消")
            //     });
            // },
            toZhifu(orderId){
                if (this.payType == 0) {
                    this.zhifu(orderId)
                }
                if (this.payType == 2) {
                    this.notify(orderId,this.payType)
                }
            },
            async zhifu(orderId) {
                let res = await this.$post('/api/unifiedOrder', {
                    orderId: orderId
                })
                // this.$toast.clear
                this.params = res
                if (typeof WeixinJSBridge === 'undefined') {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(this.params), false)
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(this.params))
                        document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(this.params))
                    }
                } else {
                    this.onBridgeReady(this.params)
                }
            },

            async notify(orderId,payType) {
                let res = await this.$post('/spm/notify', {
                    orderId: orderId,
                    payType: payType
                })
                if (res.code == 200) {
                    this.$router.push('/success/' + this.deptId+'/1')
                    // this.$notify({
                    //     message: res.message,
                    //     duration: 1000,
                    //     background: 'red'
                    // });
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },

            onBridgeReady(params) {
                const that = this
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest',
                    {
                        appId: params.appId, // 公众号名称，由商户传入
                        timeStamp: params.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: params.nonceStr, // 支付签名随机串，不长于 32 位
                        package: params.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: params.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: params.paySign // 支付签名
                    },
                    function (res) {
                        if (res.err_msg == 'get_brand_wcpay_request:ok') {
                            that.$router.push('/success/' + that.deptId+'/1')
                        }
                        if (res.err_msg == 'get_brand_wcpay_request:fail') {
                            that.$notify({
                                message: '支付失败',
                                duration: 1000,
                                background: 'red'
                            });
                        }
                    }
                )
            },

            copy() {
                this.copyText = this.$refs.p.innerText;
                var input = document.createElement("input"); // 直接构建input
                input.value = this.copyText; // 设置内容
                if (input.value) {
                    this.$toast('复制成功');
                }
                document.body.appendChild(input); // 添加临时实例
                input.select(); // 选择实例内容
                document.execCommand("Copy"); // 执行复制
                document.body.removeChild(input); // 删除临时实例
            },
        },
    };
</script>

<style lang="scss" scoped>

    .ddxq {
        padding-top: 46px;
        padding-bottom: 50px;
        overflow: scroll;
        background-color: #EEEEEE;
        height: 100%;
    }

    ::v-deep .van-nav-bar__title {
        max-width: 60%;
        margin: 0 auto;
        color: #323233;
        font-weight: 500;
        font-size: 15px;
    }

    ::v-deep .van-cell {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 5px 10px;
        overflow: hidden;
        color: #323233;
        font-size: 0.37333rem;
        line-height: 0.64rem;
        background-color: #fff;
    }

    .van-cell__right-icon {
        margin: auto;
        margin-left: 0.10667rem;
        color: #969799;
    }

    .ddxq-ads {
        height: 85px;
        background-color: #FFFFFF;
        margin: 0px 5px;
        margin-top: 5px;
        padding: 0px 8px;
        border-radius: 10px;
    }

    .ads-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 70px;
    }

    .ads-info span {
        font-size: 12px
    }

    .zhongbu {
        border-radius: 10px;
        padding: 8px 0px;
        background-color: #FFFFFF;
    }

    .spu-item {
        background-color: #FFFFFF;
        width: 90%;
        margin: auto;
        margin-bottom: 5px;
    }

    .odqx-btn {
        margin-right: 8px;
        border: #BBBBBB solid 1px;
        height: 23px;
    }

    .odzf-btn {
        border: #ff4d51 solid 1px;
        height: 23px;
        margin-right: 18px;
        color: #ff4d51;
    }
    .radio-btn {
        height: 30px;
        font-size: 13px;
    }

    ::v-deep .van-radio__icon {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -ms-flex: none;
        flex: none;
        height: 1em;
        font-size: 13px;
        line-height: 1em;
        cursor: pointer;
        position: relative;
        left: 90%;
    }
</style>
